import type { AppointmentType } from '@bb/domain/dist/types';

const correctShowingTypeLabel = (
  type: AppointmentType | 'APPOINTMENT' | 'ROUTE_STOP' | 'Information Request',
) => {
  switch (type) {
    case 'Agent Inspection':
      return 'Agent Inspection/Preview';
    default:
      return type;
  }
};

export default correctShowingTypeLabel;
